export default "__VITE_ASSET__DTRNZGMd__"